import { logOff, sessionCache } from "modules/auth";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { checkSession } from "services";
import { RootState } from "store";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "routing";


export const CheckSession = () => {
    const signIn = useSelector((state: RootState) => state.signIn);
    const dispatch = useDispatch();
    const history = useHistory();
    
    const ping = useCallback(async () => {
        if (!signIn.signInSuccess || !signIn.user?.ePoljoprivredaGuid) return;
        const isSessionActive = await checkSession(signIn.user?.accessToken);
        sessionCache()?.updateIsActive(isSessionActive);
        
        if (!isSessionActive) {
            toast.info("Vaša sesija na sustavu ePoljoprivreda je istekla.");
            dispatch(logOff());
            history.replace(AppRoutes.Home);
        }
    }, [signIn, dispatch, history]);

    useEffect(() => {
        window.onfocus = ping;

        ping();
    }, [ping]);

    return <></>;
};

export default CheckSession;
